import Role from './role.model'
const lang = require(`@/lang/${selected_lang}/auth.js`) || require(`../lang/${selected_lang}/auth`);

let storeContent = utils.generateStore({
   Role,
   roles: [],
   resourcesGroups: [],
   currentSelection: {},
   selectedRoles: [],
   activeAccordion: null
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async addRole(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'insert',
                  data: {
                     record: {
                        code: data.code,
                        name: data.name,
                        resources: await ctx.dispatch('getChangedPermissions'),
                     }
                  },
                  meta_data: {
                     service: "user",
                     collection: "role",
                  }
               })

               //Reset content
               payload.ref.resetForms()
               await ctx.dispatch('resetSelection')
               ctx.commit('activeAccordion', null)
               
               await ctx.dispatch('fetchRoles')
               ctx.commit('show_create_modal', false)
               $notify('success', 'Role Created', `Role ${data.name} successfully created.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      getChangedPermissions(ctx){
         try {
            let changed = []

            for (const [key,resource] of Object.entries(ctx.getters.currentSelection)) {
               if(resource.create || resource.read || resource.update || resource.delete || resource.verify){
                  changed.push({
                     code: key,
                     permissions: [resource.create, resource.read, resource.update, resource.delete, resource.verify]
                  })
               }
            }

            return changed
         } catch (err) {
            throw(err)
         }
      },
      async editRole(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selectedRoles[0]._id,
                     record: {
                        name: data.name,
                        resources: await ctx.dispatch('getChangedPermissions'),
                     }
                  },
                  meta_data: {
                     service: "user",
                     collection: "role",
                  }
               })

               //Reset content
               await payload.ref.resetForms()
               await ctx.dispatch('resetSelection')
               ctx.commit('activeAccordion', null)
               
               await ctx.dispatch('fetchRoles')
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Role Updated', `Role ${data.name} successfully updated.`,5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteRole(ctx, payload) {
         try {
            ctx.commit('loading', true)
            for (const role of ctx.getters.selectedRoles) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: role._id,
                  },
                  meta_data: {
                     service: "user",
                     collection: "role",
                  }
               })
            }

            
            ctx.commit('show_delete_modal', false)
            await ctx.dispatch('fetchRoles')
            $notify('success', 'Role(s) Deleted', `${ctx.getters.selectedRoles.length} roles successfully deleted.`,5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      resetSelection(ctx){
         let currentSelection = ctx.getters.currentSelection

         // Reset the current selection
         for (const [key,resource] of Object.entries(currentSelection)) {
            currentSelection[key] = {
               create: false,
               read: false,
               update: false,
               delete: false,
               verify: false,
            }
         }

         ctx.commit('currentSelection', currentSelection)
      },
      async handleActions(ctx,payload){
         if(payload.action === 'role:edit'){
            Event.$emit('loader:show',true)
            await ctx.dispatch('resetSelection')
            let Role = ctx.getters.Role, currentSelection = ctx.getters.currentSelection
            Role.forms.editRole.data = payload.rows[0]
            console.log(payload.rows[0])

            // Select the current selections
            for (const resource of payload.rows[0].resources) {
               currentSelection[resource.code] = {
                  create: resource.permissions[0],
                  read: resource.permissions[1],
                  update: resource.permissions[2],
                  delete: resource.permissions[3],
                  verify: resource.permissions[4],
               }
            }

            ctx.commit('activeAccordion',null)
            ctx.commit('Role',Role)
            ctx.commit('show_edit_modal',true)
            ctx.commit('selectedRoles',payload.rows)
            Event.$emit('loader:show',false)
         }else if(payload.action === 'role:delete'){
            ctx.commit('delete_message',` ${payload.rows.length} role(s)`)
            ctx.commit('show_delete_modal',true)
            ctx.commit('selectedRoles',payload.rows)
         }
      },
      async fetchRoles(ctx){
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {},
               meta_data: {
                  service: "user",
                  collection: "role",
               }
            })
            ctx.commit('roles',res.result.records)
         } catch (err) {
            throw err
         }
      },
      async fetchGroupedResources(ctx){
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'urmg',
               action: 'resource:get_all',
               data: {},
               meta_data: {}
            })
            
            ctx.commit('resourcesGroups',res.result.resources)

            let currentSelection = {}
            for (const group of ctx.getters.resourcesGroups) {
               for (const resource of group.resources) {
                  currentSelection[resource.code] = {
                     create: false,
                     read: false,
                     update: false,
                     delete: false,
                     verify: false,
                  }
               }
            }
            ctx.commit('currentSelection',currentSelection)
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx){
         try {
            ctx.commit('show', false)
            await ctx.dispatch('fetchRoles')
            await ctx.dispatch('fetchGroupedResources')
            Event.$emit('loader:show',false)
         } catch (err) {
            throw err
         }
      },
      openAccordion(ctx,number){
         try {
            if(ctx.getters.activeAccordion !== number){
               ctx.commit('activeAccordion',number)
            }else{
               ctx.commit('activeAccordion',null)
            }
         } catch (err) {
            throw err
         }
      },
      exportCSV(ctx,payload){
         try {
            payload.exportCsv(ctx.getters.Role.tables.roles.props)
         } catch (err) {
            throw err
         }
      },
      openCreateModal(ctx){
         try {
            ctx.dispatch('resetSelection')
            ctx.commit('show_create_modal',true)
         } catch (err) {
            throw err
         }
      },
   }
};